import { createFileRoute, redirect } from "@tanstack/react-router";
import { parseChoosePlanRedirect } from "@/lib/internal-redirect";

// Legacy path. Kept so indexed links and older emails still land on the plan
// picker instead of a 404.
export const Route = createFileRoute("/choose-trial")({
	validateSearch: (search: Record<string, unknown>) => ({
		redirect: parseChoosePlanRedirect(search.redirect) ?? undefined,
	}),
	beforeLoad: ({ search }) => {
		throw redirect({
			to: "/choose-plan",
			search: { redirect: search.redirect, reason: undefined },
			replace: true,
		});
	},
});
